import { SvgIcon } from '@mui/material'
import React from 'react'

export const CheckboxIcon: React.FC<{
  check?: boolean
  indeterminate?: boolean
}> = ({ check, indeterminate }) => {
  if (indeterminate)
    return (
      <SvgIcon sx={{ fontSize: '16px' }}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="4" fill="#001DE0" />
          <path
            d="M12.0833 8.58333H3.91663V7.41667H12.0833V8.58333Z"
            fill="#FEFEFF"
          />
        </svg>
      </SvgIcon>
    )

  return check ? (
    <SvgIcon sx={{ fontSize: '16px' }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="16" height="16" rx="4" fill="#001DE0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6949 4.7051C12.8262 4.83637 12.8999 5.01438 12.8999 5.2C12.8999 5.38561 12.8262 5.56363 12.6949 5.6949L7.09494 11.2949C6.96367 11.4261 6.78566 11.4998 6.60004 11.4998C6.41443 11.4998 6.23641 11.4261 6.10514 11.2949L3.30514 8.4949C3.17763 8.36288 3.10707 8.18606 3.10867 8.00252C3.11026 7.81898 3.18388 7.64341 3.31367 7.51363C3.44345 7.38384 3.61902 7.31022 3.80256 7.30863C3.9861 7.30703 4.16292 7.37759 4.29494 7.5051L6.60004 9.8102L11.7051 4.7051C11.8364 4.57387 12.0144 4.50015 12.2 4.50015C12.3857 4.50015 12.5637 4.57387 12.6949 4.7051Z"
          fill="#FEFEFF"
        />
      </svg>
    </SvgIcon>
  ) : (
    <SvgIcon sx={{ fontSize: '16px' }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#FEFEFF" />
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="3.5"
          stroke="#DCDBDC"
        />
      </svg>
    </SvgIcon>
  )
}
